<template>
  <div class="header_section">
    <record-status-selector
      class="record_state--selector"
      :record="record.record"
      :label="currentState"
    ></record-status-selector>

    <div class="entered_status">
      <p class="entered_status--label">Entered Status</p>
      <p class="entered_status--date">{{ (activeRecordStatus) ? formatDate(activeRecordStatus.created_at) : '' }}</p>
    </div>
  </div>
</template>

<script>

import dates from "../../../services/dates";

export default {
  name: "RecordState",
  computed: {
    record() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord : {
        record: {},
        recordStatuses: [],
      };
    },
    activeRecordStatus() {
      return this.record.recordStatuses.find(status => status.is_active);
    },
    currentState() {
      if(this.activeRecordStatus) {
        return this.$store.getters['pipeline/getStateLabelByStatusId'](this.activeRecordStatus.status_id);
      }
    },
  },
  methods: {
    formatDate(isoString) {
      return dates.formatAsDate(isoString);
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.header_section {
  display: flex;
  align-items: center;
  margin-right: 20px;

  @include mobile {
    flex-wrap: wrap;
    align-items: start;
    margin: 10px 0;
  }
}

.record_state--selector {

  @include mobile {
    margin-right: 10px;
  }
}

.entered_status {
  margin-left: 10px;

  &--label {
    margin-bottom: 4px;
    font-size: 8px;
    color: $text-muted;
  }

  &--date {
    color: $text-muted;
  }

  @include mobile {
    display: flex;
    flex-grow: 1;
    margin: 10px 0 0;

    &--label {
      margin-bottom: 0;
      font-size: 0.75rem;
    }

    &--date {
      margin-left: 6px;
      font-size: 0.75rem;
    }
  }
}
</style>
